import {Centre} from "../styled/Center.styled";

function SignIn(props) {
    return <Centre>
      <h1>Sign In</h1>
      <p>To be added soon!!!</p>
  </Centre>;
}

export default SignIn;